import intl from 'react-intl-universal'

export const sexList = [
    { value: 1, label: 'Mr.' },
    { value: 2, label: 'Mrs.' },
    { value: 3, label: 'X' }
];
